import React from 'react';
import { ISocialIcon, ISocialIconProps } from './SocialIcon';

export const YoutubeIcon: ISocialIcon = React.forwardRef<SVGSVGElement, ISocialIconProps>((props, ref) => (
  <svg className={props.className} width="33" height="33" viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.0736 6.58744C30.46 6.96065 31.54 8.0483 31.9034 9.43729C32.3656 11.9943 32.5899 14.5885 32.5734 17.1869C32.5899 19.7852 32.3656 22.3795 31.9034 24.9365C31.54 26.3255 30.46 27.4131 29.0736 27.7863C26.5737 28.4563 16.5742 28.4563 16.5742 28.4563C16.5742 28.4563 6.56475 28.4563 4.07488 27.7863C2.68848 27.4131 1.60846 26.3255 1.24503 24.9365C0.782854 22.3795 0.558574 19.7852 0.575066 17.1869C0.558574 14.5885 0.782854 11.9943 1.24503 9.43729C1.60846 8.0483 2.68848 6.96065 4.07488 6.58744C6.57475 5.91748 16.5742 5.91748 16.5742 5.91748C16.5742 5.91748 26.5737 5.91748 29.0736 6.58744ZM21.6639 17.1869L13.3044 12.4271V21.9466L21.6639 17.1869Z"
      fill="currentColor"
    ></path>
  </svg>
));
YoutubeIcon.displayName = 'YoutubeIcon';
